import { useEffect, useState } from "react";
import {
  FaStar,
  FaQuoteLeft,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Rahul Sharma",
      designation: "Residential Client",
      image: "/images/testimonials/client-1.jpg",
      review:
        "AZ Construction delivered our dream home exactly as promised. The quality of work, transparency and professionalism were outstanding.",
    },
    {
      name: "Amit Verma",
      designation: "Commercial Project Owner",
      image: "/images/testimonials/client-2.jpg",
      review:
        "Their project management and timely delivery exceeded our expectations. We highly recommend AZ Construction for commercial projects.",
    },
    {
      name: "Neha Patel",
      designation: "Property Investor",
      image: "/images/testimonials/client-3.jpg",
      review:
        "From property consultation to documentation support, the entire process was smooth and hassle-free.",
    },
  ];

  const [current, setCurrent] = useState(0);

  const nextSlide = () => {
    setCurrent((prev) =>
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrent((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="py-12 md:py-24 bg-slate-50 overflow-hidden">
      <div className="container-custom">

        {/* Heading */}

        <div className="text-center max-w-3xl mx-auto mb-16">

          <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
            Testimonials
          </span>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#082B57] mt-4">
            What Our
            <span className="text-[#F59E0B]"> Clients Say</span>
          </h2>

          <p className="text-gray-600 mt-6 leading-8">
            Our success is measured by the satisfaction of our clients.
          </p>

        </div>

        {/* Testimonial Card */}

        <div className="max-w-5xl mx-auto relative">

          <AnimatePresence mode="wait">

            <motion.div
              key={current}
              initial={{
                opacity: 0,
                y: 40,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              exit={{
                opacity: 0,
                y: -40,
              }}
              transition={{
                duration: 0.4,
              }}
              className="bg-white rounded-3xl shadow-xl border border-gray-100 p-6 md:p-12"
            >

              <div className="flex justify-between items-center mb-6">

                <div className="flex gap-1 text-[#F59E0B]">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} />
                  ))}
                </div>

                <FaQuoteLeft className="text-5xl text-[#F59E0B]/20" />

              </div>

              <p className="text-gray-600 text-base md:text-lg leading-8 md:leading-9">
                "{testimonials[current].review}"
              </p>

              <div className="flex items-center gap-4 mt-10">

                <img
                  src={testimonials[current].image}
                  alt={testimonials[current].name}
                  className="w-16 h-16 rounded-full object-cover border-2 border-[#F59E0B]"
                />

                <div>

                  <h4 className="font-bold text-[#082B57] text-lg">
                    {testimonials[current].name}
                  </h4>

                  <p className="text-gray-500">
                    {testimonials[current].designation}
                  </p>

                </div>

              </div>

            </motion.div>

          </AnimatePresence>

          {/* Navigation */}

          <div className="flex justify-center gap-4 mt-10">

            <button
              onClick={prevSlide}
              className="w-12 h-12 rounded-full bg-white shadow-md border border-gray-200 flex items-center justify-center hover:bg-[#082B57] hover:text-white transition"
            >
              <FaChevronLeft />
            </button>

            <button
              onClick={nextSlide}
              className="w-12 h-12 rounded-full bg-[#F59E0B] text-white shadow-md flex items-center justify-center hover:bg-orange-600 transition"
            >
              <FaChevronRight />
            </button>

          </div>

          {/* Dots */}

          <div className="flex justify-center gap-3 mt-8">

            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrent(index)}
                className={`w-3 h-3 rounded-full transition ${
                  current === index
                    ? "bg-[#F59E0B] w-8"
                    : "bg-gray-300"
                }`}
              />
            ))}

          </div>

        </div>

      </div>
    </section>
  );
};

export default Testimonials;